<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" data-cy="power-profile-dialog-form">
    <mat-form-field class="w-full">
      <mat-label>Profile Name</mat-label>
      <input matInput formControlName="name" type="text" data-cy="power-profile-dialog-name-input" />
      @if (form.get('name')?.hasError('required')) {
        <mat-error data-cy="power-profile-name-error">Profile Name is required</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Max Power (W)</mat-label>
      <input matInput formControlName="maximumWattage" type="number" min="0" data-cy="power-profile-dialog-maximum-wattage-input" />
      @if (form.get('maximumWattage')?.hasError('required')) {
        <mat-error data-cy="power-profile-max-wattage-required-error">Max Power is required</mat-error>
      }
      @if (form.get('maximumWattage')?.hasError('min')) {
        <mat-error data-cy="power-profile-max-wattage-min-error">Max Power must be greater than or equal to 0</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Standby Power (W) Uses default value if empty</mat-label>
      <input matInput formControlName="standbyWattage" type="number" min="0" data-cy="power-profile-dialog-standby-wattage-input" />
      @if (form.get('standbyWattage')?.hasError('min')) {
        <mat-error data-cy="power-profile-standby-wattage-min-error">Standby Power must be greater than or equal to 0</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Base Power (W) Uses default value if empty</mat-label>
      <input matInput formControlName="baseWattage" type="number" min="0" data-cy="power-profile-dialog-base-wattage-input" />
      @if (form.get('baseWattage')?.hasError('min')) {
        <mat-error data-cy="power-profile-base-wattage-min-error">Base Power must be greater than or equal to 0</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" data-cy="power-profile-dialog-cancel">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid" data-cy="power-profile-dialog-save">
    {{ submitLabel }}
  </button>
</mat-dialog-actions>
